// extracted by mini-css-extract-plugin
export default {"imgHover":"EditPost_imgHover__r012V"};